import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LazyLoadModule } from './lazy-load/lazy-load.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { ApisService } from './services/apis.service';
import { HttpModule } from '@angular/http';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MAT_DATE_LOCALE, MatDialogModule, MatSnackBarModule} from '@angular/material';
import { DialogComponent } from './components/dialog/dialog.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    SnackbarComponent,
    DialogComponent
  ],
  imports: [
    BrowserModule,
    LazyLoadModule,
    CoreModule,
    BrowserAnimationsModule,
    HttpModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
  providers: [
      ApisService,
      SnackbarComponent,
      DialogComponent,
      {provide: MAT_DATE_LOCALE, useValue: 'es'},
      {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent],
  entryComponents: [DialogComponent]
})
export class AppModule { }
